import * as React from 'react';
function SvgFaviconEts(props) {
    return (React.createElement("svg", Object.assign({ width: 56, height: 56, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M55.5 46.517v.002a8.945 8.945 0 01-8.976 8.981H.698a.198.198 0 01-.198-.2h0V.698C.5.588.589.5.698.5h54.604c.11 0 .198.089.198.198v45.819z", fill: "#fff", stroke: "#7CC356" }),
        React.createElement("path", { d: "M18.151 42H11.2c0-11.819 2.958-19.322 2.958-19.322C13.197 35.393 18.15 42 18.15 42zM46.2 14s-22.052 9.344-26.141 28H38.62s-13.333-3.744 7.58-28z", fill: "#7CC356" })));
}
export default SvgFaviconEts;
//# sourceMappingURL=FaviconEts.js.map